import React, { useState } from "react";
import "./PasswordProtected.css";
import { ASSETS_URI } from "../../../config";
import Service from "../../../Action/service";
import { toast } from "react-toastify";

const EmailOtpVerification = ({ pdf, setisVerified }) => {
  const [step, setStep] = useState(1); // 1=email, 2=otp
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [loading, setLoading] = useState(false);

  /* ===================== EMAIL SUBMIT ===================== */
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
      setLoading(true);

      // 🔐 SEND OTP API
      await Service.post(`/public/sendemailforverification`, {
        email,
        pdf_id: pdf.pdfID,
        client_id: pdf?.clientID,
      });

      setStep(2);
    } catch (err) {
      toast.error(err.response.data.message)
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ===================== OTP HANDLERS ===================== */
  const handleOtpChange = async (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }

  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };

  /* ===================== OTP SUBMIT ===================== */
  const handleOtpSubmit = async (e) => {
    e.preventDefault();

    const finalOtp = otp.join("");
    if (finalOtp.length !== 6) return;

    try {
      setLoading(true);


      await Service.post(`/public/confirmotp`, {
        email,
        pdf_id: pdf.pdfID,
        client_id: pdf?.clientID,
        otp: finalOtp
      });

      setisVerified(false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pp-overlay">
      <div className="pp-popup">
        <div className="pp-popup-body">
          {/* ================= LEFT ================= */}
          <div className="pp-left pp-card">
            <h4>
              {step === 1
                ? "Enter your email address"
                : "Enter OTP to continue"}
            </h4>

            <p>
              {step === 1
                ? "You will receive an email OTP if you have been invited to view this document"
                : `Enter the OTP sent to ${email} to securely access this document.`}
            </p>

            {/* ================= STEP 1 : EMAIL ================= */}
            {step === 1 && (
              <form onSubmit={handleEmailSubmit}>
                <div className="pp-input">
                  <input
                    required
                    type="email"
                    placeholder="Enter email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <button
                  className="pp-btn"
                  type="submit"
                  disabled={loading}
                  style={{
                    backgroundColor: window.__E_TT_Client.primary,
                  }}
                >
                  {loading ? "SENDING..." : "SEND OTP"}
                </button>
              </form>
            )}

            {/* ================= STEP 2 : OTP ================= */}
            {step === 2 && (
              <form onSubmit={handleOtpSubmit}>
                <div className="pp-otp-wrapper">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-${index}`}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      className="pp-otp-input"
                      value={digit}
                      onChange={(e) =>
                        handleOtpChange(e.target.value, index)
                      }
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      autoFocus={index === 0}
                    />
                  ))}
                </div>

                <button
                  className="pp-btn"
                  type="submit"
                  disabled={loading}
                  style={{
                    backgroundColor: window.__E_TT_Client.primary,
                  }}
                >
                  {loading ? "VERIFYING..." : "VERIFY OTP"}
                </button>

                <span
                  className="eo-back"
                  onClick={() => {
                    setStep(1);
                    setOtp(Array(6).fill(""));
                  }}
                >
                  ← Change email
                </span>
              </form>
            )}
          </div>

          {/* ================= RIGHT ================= */}
          <div className="pp-right">
            <div className="pp-card pp-card-right">
              <img
                src={pdf?.pdfcoverPath ?? `${ASSETS_URI}/${pdf?.coverImage}`}
                alt="PDF"
                className="pp-pdf"
              />

              <h2 className="pp-pdf-name">
                {pdf?.pdfName || pdf?.titleName || "Untitled PDF"}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailOtpVerification;
